import Vue from 'vue'
import Router from 'vue-router'
import { META } from './assets/javascript/meta'

Vue.use(Router)

let routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('./views/Home.vue'),
    meta: META.java
  },
  {
    path: '/embed/',
    name: 'embed',
    component: () => import('./views/EmbedApp'),
    children: [
      {
        path: '/embed/itext',
        name: 'embedIText',
        component: () => import('./views/EmbedIText'),
        meta: META.java
      }
    ]
  }
]

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})
